import { useCustomTranslation } from '../../../localization/hooks/useCustomTranslation';
import { moduleId } from '../config';

export const useEventTranslation = (keyPrefix: string) =>
  useCustomTranslation({ moduleId, keyPrefix });
